<template>
  <TextBlock v-bind="$attrs" :content="textBlock" />
</template>

<script setup lang="ts">
import gql from '@/gql/contentful';

type Props = {
  id: string;
};

const props = defineProps<Props>();

const { fetchEntryWithGraphQL } = useContentful();

const { data } = await useAsyncData(props.id, async () => {
  const { data, error } = await fetchEntryWithGraphQL(gql.getTextBlock, {
    id: props.id,
  });

  if (error) {
    return { data: null, error };
  }

  return { data, error: null };
});

const textBlock = computed(() => (data.value as any).data);
</script>

<script lang="ts">
export default defineComponent({
  name: 'ContentPageTextBlock',
});
</script>
